module.exports = __webpack_public_path__ + "img/tax.859527ea.png";